module.exports = __webpack_public_path__ + "resource/img/personal-man.5e548f3e.svg";